/** The one size every PaymentKit.js checkout popup (PayPal, BNPL) opens at. */
const CHECKOUT_POPUP_SIZE = { width: 600, height: 700 } as const;

/**
 * Build a `window.open()` feature string for a checkout popup of
 * `CHECKOUT_POPUP_SIZE`, centered over the shopper's browser window. One fixed
 * size, so the PayPal and BNPL rails cannot drift apart.
 *
 * Without `left`/`top` the browser picks its own default spot (the top-left
 * of the screen in Chromium, measured), which looks off-center on desktop.
 * Mobile browsers are expected to ignore the feature string and open a tab
 * (not measured here; only desktop Chromium on macOS was checked).
 *
 * Centers on the outer frame (`screenX`/`outerWidth`), not the viewport, so
 * page zoom does not change the result. Coordinates can be negative on a
 * secondary monitor; we do not clamp. Chromium keeps the popup on screen
 * itself (measured); not yet checked in Safari/Firefox.
 *
 * Cosmetic only: it never changes what the popup navigates to.
 */
export function centeredPopupFeatures(): string {
  const { width, height } = CHECKOUT_POPUP_SIZE;
  const left = Math.round(window.screenX + (window.outerWidth - width) / 2);
  const top = Math.round(window.screenY + (window.outerHeight - height) / 2);

  return `width=${width},height=${height},left=${left},top=${top}`;
}
